module.exports = __webpack_public_path__ + "img/mythical beasts school.4f3d0d86.png";